var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateGroupAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6 2a.6.6 0 00-1.2 0v5.4H2a.6.6 0 000 1.2h5.4V14a.6.6 0 101.2 0V8.6H14a.6.6 0 100-1.2H8.6V2z",
    fill: "#626E85"
  })));
}
export default __webpack_public_path__ + "static/template-group-add.15cf7148.svg";
export { SvgTemplateGroupAdd as ReactComponent };